import { useId } from "react";
import { useT } from "../../i18n/locale";
import { Button } from "./Button";
import { Icon } from "./Icon";
import "./save-bar.css";

type Props = {
  /** Quante modifiche ci sono e le prime a parole («2 modifiche non salvate al ruolo …»). */
  summary: string;
  /** Ciò che impedisce di salvare: resta scritto, il pulsante spento non basta a spiegarlo. */
  problem?: string;
  onDiscard: () => void;
  onSave: () => void;
  saveLabel: string;
  saving: boolean;
};

// La barra delle bozze: appare quando ci sono modifiche non salvate e resta in vista in fondo alla
// pagina. Salvare è impossibile con un problema aperto o mentre un salvataggio è in corso (niente
// doppio invio); annullare, mentre si salva, no: la richiesta sta già andando.
export function SaveBar({ summary, problem, onDiscard, onSave, saveLabel, saving }: Props) {
  const t = useT();
  const problemId = useId();
  return (
    <div className="g-savebar" data-state={problem ? "problem" : saving ? "saving" : "dirty"}>
      <div className="g-savebar__text">
        <p className="g-savebar__summary">{summary}</p>
        {problem ? (
          <p id={problemId} className="g-savebar__problem">
            <Icon name="alert" />
            <span>{problem}</span>
          </p>
        ) : null}
        <p className="g-savebar__status" role="status">{saving ? t("common.saving") : null}</p>
      </div>
      <div className="g-savebar__actions">
        <Button onClick={onDiscard} disabled={saving}>{t("common.discardChanges")}</Button>
        <Button
          variant="primary"
          onClick={onSave}
          disabled={saving || Boolean(problem)}
          aria-busy={saving ? "true" : undefined}
          aria-describedby={problem ? problemId : undefined}
        >
          {saveLabel}
        </Button>
      </div>
    </div>
  );
}
